import { flatten } from "lodash";
import { useInfiniteQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";

export const useCommunityInboxSearch = (searchQuery: string) => {
  const { setChats } = useCommunityInboxStore();

  const fetchChats = (page: number) =>
    reactQueryGet(
      internalApi.search.communityInbox.chats({
        params: {
          page,
          query: searchQuery,
        },
      }),
    );

  const { fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    ["community-inbox-search", searchQuery],
    ({ pageParam = 1 }) => fetchChats(pageParam),
    {
      enabled: searchQuery.length > 0,
      getNextPageParam: lastPage =>
        lastPage.has_next_page ? lastPage.page + 1 : undefined,
      select: ({ pages = [] }) => ({
        pages: flatten(pages.map(page => page.records)),
        pageParams: pages.map(page => page.page),
        pagesList: pages,
      }),
      onSuccess: data => {
        const records = data?.pages || [];
        setChats(records, "admin");
      },
    },
  );

  return {
    fetchNextPage,
    hasNextPage,
    isLoading: isFetching,
  };
};
